export const PRODUCT_DATABASIC = 'PRODUCT_DATABASIC';
export const PRODUCT_SET_PRODUCT = 'PRODUCT_SET_PRODUCT';
export const PRODUCT_RESET_PRODUCT = 'PRODUCT_RESET_PRODUCT';
export const PRODUCT_REMOVE = 'PRODUCT_REMOVE';
